import { render, staticRenderFns } from "./SystemAccess.vue?vue&type=template&id=e628cfb0&"
import script from "./SystemAccess.vue?vue&type=script&lang=js&"
export * from "./SystemAccess.vue?vue&type=script&lang=js&"
import style0 from "./SystemAccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports